import { render, staticRenderFns } from "./Agb.vue?vue&type=template&id=8f97f228&scoped=true"
import script from "./Agb.vue?vue&type=script&lang=js"
export * from "./Agb.vue?vue&type=script&lang=js"
import style0 from "./Agb.vue?vue&type=style&index=0&id=8f97f228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f97f228",
  null
  
)

/* custom blocks */
import block0 from "./Agb.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports